import { Button, Image, Spin } from "@arco-design/web-react";
import { useRefundImage } from "../runtime/useRefundImage";

/** 经鉴权的单张凭证预览。 */
export function EvidenceImage({ teamId, id, kind, submissionId }: { teamId: string; id: string; kind: "ticket" | "refund"; submissionId?: string }) {
  const image = useRefundImage(teamId, id, kind, submissionId);
  if (image.error) return <Button size="mini" onClick={() => void image.refetch()}>图片加载失败，重试</Button>;
  return image.url ? <Image width={60} height={80} style={{ objectFit: "contain" }} src={image.url} alt={kind === "ticket" ? "本人车票" : "退票成功凭证"} /> : <Spin />;
}
